<script lang="ts">
  import { photoUrl } from './api';
  import { formatTypeLabel } from '~/shared/place-type.js';
  import type { TextSearchResult } from '~/shared/api.js';

  let {
    result,
    busy = false,
    onClose,
    onAddToTrip,
  }: {
    result: TextSearchResult;
    /** Disable the action button while a bookmark API call is in flight. */
    busy?: boolean;
    onClose: () => void;
    onAddToTrip: () => void;
  } = $props();

  const typeLabel = $derived(formatTypeLabel(result.category));
  const ratingLabel = $derived(
    result.rating !== null ? result.rating.toFixed(1) : null,
  );
  const thumb = $derived(photoUrl(result.photoReference, 240));
</script>

<div class="map-popup">
  <div
    class="close"
    role="button"
    tabindex="0"
    aria-label="Close"
    onclick={onClose}
    onkeydown={(e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onClose();
      }
    }}
  >
    <!-- Plain Unicode × in a span with inline styles — see MapPopup.svelte
         for why a styled SVG/pseudo-element doesn't render reliably inside
         Google's InfoWindow content host. -->
    <span aria-hidden="true" style="font-size: 22px; line-height: 1; font-weight: 600; color: inherit;">×</span>
  </div>
  <div class="head">
    {#if thumb}
      <div class="thumb"><img src={thumb} alt="" /></div>
    {:else}
      <div class="thumb thumb-blank"></div>
    {/if}
    <div class="head-text">
      <h3>{result.name}</h3>
      <div class="meta">
        {#if ratingLabel}
          <span class="rating">★ {ratingLabel}</span>
        {/if}
        {#if ratingLabel && typeLabel}<span aria-hidden="true">·</span>{/if}
        {#if typeLabel}<span>{typeLabel}</span>{/if}
      </div>
      {#if result.formattedAddress}
        <p class="address">{result.formattedAddress}</p>
      {/if}
    </div>
  </div>
  <div class="actions">
    <button type="button" class="primary" disabled={busy} onclick={onAddToTrip}>
      {busy ? 'Adding…' : 'Add to trip'}
    </button>
  </div>
</div>
